<template>
  <svg viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28 10.7996L36.7996 2" stroke="#BABEC5" stroke-width="3" />
    <path d="M28 2.89062L28 10.8906L36 10.8906" stroke="#BABEC5" stroke-width="3" />
    <path d="M10.7996 10.7996L2.00001 2" stroke="#BABEC5" stroke-width="3" />
    <path d="M10.7996 2.89062L10.7996 10.8906L2.79956 10.8906" stroke="#BABEC5" stroke-width="3" />
    <path d="M28 28.0911L36.7996 36.8906" stroke="#BABEC5" stroke-width="3" />
    <path d="M28 36L28 28L36 28" stroke="#BABEC5" stroke-width="3" />
    <path d="M10.7996 28.0911L2.00001 36.8906" stroke="#BABEC5" stroke-width="3" />
    <path d="M10.7996 36L10.7996 28L2.79956 28" stroke="#BABEC5" stroke-width="3" />
  </svg>
</template>
